import React, { useCallback } from "react"
import styled from "styled-components"
import { useLanguageState } from "../../globalStates/LanguageState"
import { useReferenceDataState } from "../../globalStates/ReferenceDataState"

const LanguagesWrapper = styled.div`
    display: flex;
    align-items: center;
    & > * {
        margin: 0;
        cursor: pointer;

        &.active {
            font-weight: 500;
        }
    }
`

const Languages: React.FC<{}> = (props) => {
    const languageState = useLanguageState()
    const languages = languageState.getAvailableLanguages()
    const referenceState = useReferenceDataState()

    const languageSwitchHandler = useCallback(
        (lang: string) => {
            languageState.setLanguage(lang)
            referenceState.init()
        },
        [languageState, referenceState]
    )

    if (languages.length < 2) {
        return null
    }

    return (
        <LanguagesWrapper>
            {languages.map((item: string, index: number) => {
                return (
                    <React.Fragment key={item}>
                        <label
                            className={item === languageState.getLanguage() ? "active" : ""}
                            onClick={() => languageSwitchHandler(item)}
                        >
                            {item.toUpperCase()}
                        </label>
                        {index < languages.length - 1 && <label>&nbsp;|&nbsp;</label>}
                    </React.Fragment>
                )
            })}
        </LanguagesWrapper>
    )
}

export default Languages
